
import React from 'react';
import './policies.css';

function AcceptanceOfTerms() {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Acceptance of Terms & Conditions</h1>

        <p className="last-updated">
          Last Updated: June 2026
        </p>

        <div className="policy-welcome-box">
          <p>
            By using our website, mobile application, and laundry services,
            you acknowledge and agree to comply with the Terms & Conditions
            outlined by Mr White.
          </p>
        </div>

        <div className="policy-section">
          <h2>Acceptance of Terms & Conditions</h2>

          <p>
            By placing an order through our online laundry platform, you
            confirm that you have read, understood, and agreed to these
            Terms & Conditions.
          </p>

          <p>
            Customers must actively accept these Terms & Conditions by
            selecting the <strong>"I Agree"</strong> or
            <strong> "Click to Accept"</strong> checkbox during checkout
            before confirming and submitting any laundry service request,
            pickup request, or payment.
          </p>

          <p>
            Failure to accept these Terms & Conditions will prevent the
            completion of the booking and payment process.
          </p>
        </div>

        <div className="policy-section">
          <h2>Contact Us</h2>

          <p>
            If you have any questions regarding these Terms & Conditions,
            please contact us:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>{' '}
            <a href="tel:+971585779343">
              +971 58 577 9343
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default AcceptanceOfTerms;
